export default class EmailForm {

    constructor() {
        this.rootHtml = document.querySelector('html');

        this.emailForm = document.getElementById('apply-form');

        this.emailForm.addEventListener('submit', this.handleSubmit);
        /*
        this.emailForm.addEventListener('submit', (e) => {

            return this.validateFields();
            if(!this.validateFields()) {
                e.preventDefault();
            }

        });*/
    }

    attachErrMessage(msg) {
        var div = document.createElement('div');
        div.classList.add('msg-error');
        div.innerHTML = msg.trim();
        return div;
    };

    validateField(el) {
        if(!el.value) {
            el.closest(".form-control").classList.add('has-error');

            let err = this.attachErrMessage(el.closest(".form-control").getAttribute('data-error'));
            el.closest(".form-control").append(err);
            this.success =  false;
        } else {
            el.closest(".form-control").classList.remove('has-error');
            var err = el.closest(".form-control").querySelector('.msg-error');
            if(err) err.remove();
            this.success =  true;
        }

        return this.success;
    }

    // If we wanted to validate more than one field, it could happen here.
    validateFields(){
        var fileInput = this.emailForm.querySelector('[name="applicant_resume"]');

        this.success = this.validateField(fileInput);

        fileInput.addEventListener('change', (e) => {
            this.validateField(fileInput)
        });

        return this.success;
    }

    handleSubmit = async event => {
        event.preventDefault();

        var form_status = document.getElementById("form-status");
        var data = new FormData(event.target);
        data.append("ajax", true);

        if(!this.validateFields()) {
            return false;
        }

        fetch(event.target.action, {
            method: this.emailForm.method,
            body: data,
            headers: {
                'Accept': 'application/json'
            }
        }).then(response => {
            if (response.ok) {
                response.json().then(data => {

                    if (!Object.hasOwn(data, 'errors')) {
                        form_status.querySelector('.success-msg').classList.remove('none');
                        this.emailForm.reset()
                    } else {
                        form_status.querySelector('.error-msg').classList.remove('none');
                        console.log(data.errors);

                        var form_errors = Object.keys(data.errors).map((key) => [key, data.errors[key]]);
                        form_errors.forEach( form_error => {
                            var form_control = this.emailForm.querySelector('[name*="'+form_error[0]+'"]').closest(".form-control");
                            form_control.classList.add('has-error');
                        });
                    }
                })

            } else {
                form_status.querySelector('.error-msg').classList.remove('none');
            }
        }).catch(error => {
            form_status.querySelector('.error-msg').classList.remove('none');
        });
    };
}